const obj = {
  version: "0.38.0",
};

export default obj;
